import { MsalInterceptorConfiguration } from "@azure/msal-angular";
import { IPublicClientApplication, InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "src/environments/environment";

const _apiUrl = environment.apiUrl + "/api/";
//Azure variables
const _redirectAplicationAzure = environment.redirectAplicationAzure;
const _scopesAzure = environment.scopesAzure;
const _clientIdAzure = environment.clientIdAzure;
const _authorityAzure = environment.authorityAzure;
const _me = environment.meAzure;

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: _clientIdAzure,
            authority: _authorityAzure,
            redirectUri: _redirectAplicationAzure,
        },
    });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read', 'mail.read']);
    protectedResourceMap.set(_me, ['user.read']);
    protectedResourceMap.set(`${_apiUrl}auth/`, null);
    protectedResourceMap.set(`${_apiUrl}aspirantes/`, null);
    protectedResourceMap.set(`${_apiUrl}catalogos/`, null);
    protectedResourceMap.set(_apiUrl, [_scopesAzure]);

    return {
        interactionType: InteractionType.Popup,
        protectedResourceMap,
    };
}
